<app-report-criteria-form (action)="onAction(Action.new)" (criteria)="onSearch($event)"></app-report-criteria-form>
<div *ngIf="creation; then showForm else showList"></div>
<ng-template #showForm>
  <app-report-form [creation]="true" [mode]="Mode.edition" [object]="report" (event)="onEvent($event)"></app-report-form>
</ng-template>
<ng-template #showList>
  <app-report-list #list [sorting]="sorting" (page)="onScroll()" (sort)="onSort($event)"></app-report-list>
</ng-template>

